import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "../src/styles/index.css";
import { Security, LoginCallback } from "@okta/okta-react";
import App from "./Apptwo";
import oktaConfig from "./oktaConfig";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, useNavigate, Route, Routes } from "react-router-dom";
import { OktaAuth } from "@okta/okta-auth-js";

// ✅ Fix: Override Okta’s internal restoreOriginalUri to prevent duplicate callbacks
const oktaAuth = new OktaAuth({
  issuer: oktaConfig.issuer,
  clientId: oktaConfig.clientId,
  redirectUri: oktaConfig.redirectUri,
  scopes: oktaConfig.scopes,
  pkce: oktaConfig.pkce,
  restoreOriginalUri: async () => {}, // ✅ NO-OP function to disable Okta's default behavior
});

// ✅ Function to store the full browser URL before redirecting to Okta
const savePreLoginUrl = () => {
  if (!sessionStorage.getItem("preLoginUrl")) {
    const currentUrl = window.location.href; // Store full URL with query params
    sessionStorage.setItem("preLoginUrl", currentUrl);
  }
};

// ✅ Custom Hook to restore the correct browser URL after login
const useRestoreOriginalUri = () => {
  const navigate = useNavigate();

  return async (oktaAuth, originalUri) => {
    const storedUri = sessionStorage.getItem("preLoginUrl");
    const redirectTo =
      storedUri && !storedUri.includes("/login/callback")
        ? storedUri
        : originalUri || "/";

    sessionStorage.removeItem("preLoginUrl"); // ✅ Clear after restoring
    navigate(redirectTo, { replace: true });
  };
};
/* Added this to replace /login/callback with / so auth pkce error doesn't happen */
const LoginCallbackHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/", { replace: true }); // Redirect to home after handling callback
    }, 500); // Delay to let Okta complete login

    return () => clearTimeout(timer);
  }, [navigate]);

  return <LoginCallback />;
};

const AppWrapper = () => {
  const restoreOriginalUri = useRestoreOriginalUri(); // ✅ Ensures correct URL restoration

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri} // ✅ Only defined here, NOT inside OktaAuth
      onAuthRequired={() => {
        savePreLoginUrl(); // ✅ Save URL before redirecting
        oktaAuth.signInWithRedirect();
      }}
    >
      <Routes>
        <Route path="/login/callback" element={<LoginCallbackHandler />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </Security>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
